export const SwooshLeftLight = () => {
    return (
        <svg
            width="329"
            height="157"
            viewBox="0 0 329 157"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.3"
                d="M-171 57.4563C-102.609 15.7357 -7.07344 -6.28839 126.376 29.4693C187.038 45.7236 273.748 101.863 320.748 148.743"
                stroke="url(#swoosh-left-light-gradient)"
                strokeWidth="23"
            />
            <defs>
                <linearGradient
                    id="swoosh-left-light-gradient"
                    x1="-40.7798"
                    y1="45.7614"
                    x2="809.765"
                    y2="270.64"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DEEBFF" />
                    <stop
                        offset="0.411458"
                        stopColor="#DEEBFF"
                        stopOpacity="0"
                    />
                    <stop
                        offset="0.526042"
                        stopColor="#DEEBFF"
                        stopOpacity="0"
                    />
                    <stop offset="1" stopColor="#EAE6FF" />
                    <stop offset="1" stopColor="#DEEBFF" />
                </linearGradient>
            </defs>
        </svg>
    );
};
